import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { PersonPointDTO } from 'app/dtos/person-point/person-point';

@Injectable({
  providedIn: 'root'
})
export class PersonPointService {

  constructor(private httpClientService:HttpClientService) { }

  async getAllPersonPoint(page,size,search){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.PersonPoint,
      queryString:`page=${page}&size=${size}&search=${search}`
    });
    return await firstValueFrom(observable);
  }

  async getPersonPoints(page,size,search,personId,startDate?:string,endDate?:string){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.PersonPoint,
      queryString:`page=${page}&size=${size}&search=${search}&personId=${personId}&startDate=${startDate}&endDate=${endDate}`,
      action:"GetPersonPoints"
    });
    return await firstValueFrom(observable);
  }

  async getByIdPersonPoint(id){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.PersonPoint
    },id);
    return await firstValueFrom(observable);
  }

  async calculatePersonPoints(id){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.PersonPoint,
      action:"CalculatePersonPoints"
    },id);
    return await firstValueFrom(observable);
  }

  async cretaPersonPoint(createPersonPoint:PersonPointDTO){
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.PersonPoint
    },
    {
      personId:createPersonPoint.personId,
      workStart:createPersonPoint.workStart,
      workEnd:createPersonPoint.workEnd,
      workRate:createPersonPoint.workRate,
      overtimeHours:createPersonPoint.overtimeHours,
      status:createPersonPoint.status
    });
    return await firstValueFrom(observable);
  }

  async updatePersonPoint(updatePersonPoint:PersonPointDTO){
    const observable:Observable<any> = this.httpClientService.put({
      controller:ControllerType.PersonPoint
    },
    {
      id:updatePersonPoint.id,
      personId:updatePersonPoint.personId,
      workStart:updatePersonPoint.workStart,
      workEnd:updatePersonPoint.workEnd,
      workRate:updatePersonPoint.workRate,
      overtimeHours:updatePersonPoint.overtimeHours,
      status:updatePersonPoint.status
    });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }

}
